// Which scanned text lines to highlight for a field value (FieldHighlight.js). Pure, so it can be unit tested.
const digits = s => (s || '').replace(/[^0-9]/g, '');
const squash = s => (s || '').toLowerCase().replace(/[\s,]/g, '');
const numbersIn = text => ((text || '').match(/-?\d[\d,]*(\.\d+)?/g) || []).map(n => Number(n.replace(/,/g, ''))).filter(n => !Number.isNaN(n));

// value: the field's value as shown (text, "4,285.00", or an <input type="date"> value "2026-09-01").
export function candidates(value) {
	const v = (value || '').trim();
	if (!v) return null;
	const iso = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (iso) {
		const [, y, m, d] = iso; const mi = Number(m), di = Number(d);
		const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
		return { kind: 'date', texts: [`${m}/${d}/${y}`, `${mi}/${di}/${y}`, `${m}/${d}/${y.slice(2)}`, `${mi}/${di}/${y.slice(2)}`, `${y}-${m}-${d}`, `${d}/${m}/${y}`, `${m}-${d}-${y}`, `${months[mi - 1]}${di}`, `${di}${months[mi - 1]}`].map(squash) };
	}
	if (/^-?[\d,]+(\.\d+)?$/.test(v)) {
		const n = Number(v.replace(/,/g, ''));
		return n === 0 ? null : { kind: 'number', value: n };
	}
	return v.length >= 2 ? { kind: 'text', text: squash(v) } : null;
}

export function matchBlocks(blocks, value, page = 1) {
	const c = candidates(value);
	if (!c || !Array.isArray(blocks)) return [];
	return blocks.filter(b => (b.page || 1) === page && (() => {
		const t = squash(b.text);
		if (c.kind === 'date') return c.texts.some(x => t.includes(x)) || (digits(b.text).length >= 6 && c.texts.some(x => digits(x).length >= 6 && digits(b.text).includes(digits(x))));
		if (c.kind === 'number') return numbersIn(b.text).some(n => Math.abs(Math.abs(n) - Math.abs(c.value)) < 0.005);
		return t.includes(c.text);
	})());
}
